import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { InstructionsPreviewDialogComponent } from './instructions-preview-dialog.component';

export const ngxInstructionsPreviewDialogModule = angular.module('ngxInstructionsPreviewDialogModule', [])
	.directive('ngxInstructionsPreviewDialog', downgradeComponent({ component: InstructionsPreviewDialogComponent }))
	.name;
